// Section 4 phase 9 and Section 20: the steady-state check at the end of Winter, loss checks
// every season (a breakdown sends the distrustful households away), the Ledger accumulation
// (Section 21, after everything this season did, ADR-0017), then the season is closed: the
// report moves to history and the clock advances.
import type { Phase } from '../../core/types';
import { checkLoss, checkSteady } from './check';
import { closeSeason } from './close';
import { accumulateLedger } from './ledger';

export const steadyPhase: Phase = {
  id: 'steady',
  reads: ['history', 'series', 'people', 'buildings', 'stocks', 'safety', 'counters', 'options'],
  writes: [
    'steady',
    'outcome',
    'sandbox',
    'history',
    'currentReport',
    'season',
    'year',
    'promptAnswers',
    'counters',
    'ledger',
    // Section 20 breakdown: households leave (phases/shared/depart.ts).
    'people',
    'households',
    'formerPeople',
    'stocks',
    'plantedPlots',
    'toolOverrides',
    'triageOverrides',
    'rationOverrides',
    'myHousehold',
  ],
  projection: 'run',
  run(ctx) {
    if (ctx.season.isYearEnd) checkSteady(ctx);
    checkLoss(ctx);
    accumulateLedger(ctx);
    closeSeason(ctx);
    return 'done';
  },
};
